import Enum from "./Enum";

export default Enum.create( {
	NOOP: "NOOP",
	LOGIN: "LOGIN",
	SIGNUP: "SIGNUP",
	CALENDAR: "CALENDAR",
	SILENT: "SILENT",
} );
